import { doFetch } from "@Src/api/apiFetchHelper";

export const getTravelStats = () => {
  return doFetch(`/api/travel-stats`).then((response) => {
    return response.data;
  });
};

export default { getTravelStats };
